import request from '@/utils/request'

const baseUrl = '/erp/purchase-order'

export const pagePurchaseOrder = params => request({ url: baseUrl + '/page', method: 'get', params })
export const getPurchaseOrder = id => request({ url: baseUrl + '/detail', method: 'get', params: { id } })
export const savePurchaseOrder = data => request({ url: baseUrl + '/save', method: 'post', data })
export const auditPurchaseOrder = id => request({ url: baseUrl + '/audit', method: 'post', data: { id } })
export const reverseAuditPurchaseOrder = id => request({ url: baseUrl + '/reverse-audit', method: 'post', data: { id } })
export const deletePurchaseOrder = id => request({ url: baseUrl + '/delete', method: 'post', data: { id } })
export const listPurchaseOrderInboundOptions = keyword => request({
  url: baseUrl + '/inbound-options', method: 'get', params: { keyword }
})
export const getPurchaseOrderCreator = () => request({ url: baseUrl + '/creator-profile', method: 'get' })
export const listPurchaseOrderWarehouses = supplierId => request({
  url: baseUrl + '/supplier-warehouses', method: 'get', params: { supplierId }
})
export const listPurchaseOrderSku = (supplierId, warehouseId, keyword) => request({
  url: baseUrl + '/sku-options', method: 'get', params: { supplierId, warehouseId, keyword }
})
export const exportPurchaseOrder = params => request({
  url: baseUrl + '/export',
  method: 'get',
  params,
  responseType: 'blob'
})
